import { render, staticRenderFns } from "./companyname.vue?vue&type=template&id=6ba6d2b1&"
import script from "./companyname.vue?vue&type=script&lang=js&"
export * from "./companyname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports